<style lang="scss" scoped>
.body_table_header_box {
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
  border-bottom: 1px solid #e0e3eb;
  padding: 0 20px;
  box-sizing: border-box;

  >span {
    padding: 0 12px;
    border-right: 1px solid #e0e3eb;
    color: #666666;
    font-size: 14px;
  }

  >span:first-child {
    padding-left: 0;
  }

  >span:last-child {
    border-right: none;
  }
}

.body_table_content_box {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background-color: #fff;
}

::v-deep .el-table__body-wrapper {
  overflow-y: scroll !important;
  height: calc(100% - 45px);
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.body_table_box {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  .body_table_title_box {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    border-bottom: 1px solid #eee;

    ::v-deep .el-link--inner {
      margin-left: 3px;
      font-size: 12px;
    }

    .body_table_title_left {
      padding-left: 10px;
      flex: 1;
      color: #909399;

      .el-button {
        border-radius: 2px;
        height: 32px;
        min-width: 80px;
        padding: 0 15px;
        font-size: 12px;
      }
    }

    i {
      font-size: 14px;
      cursor: pointer;
      margin-left: 10px;
    }
  }

  .span {
    line-height: 22px;
    margin-right: 10px;
    border-radius: 2px;
    box-sizing: border-box;
    vertical-align: middle;
  }

  .markIncome {
    display: inline-block;
    height: 21px;
    line-height: 21px;
    color: #ffffff;
    background-color: #f39b13;
    font-size: 12px;
    padding: 0 6px;
  }

  .invoiced {
    display: inline-block;
    height: 21px;
    line-height: 21px;
    color: #ffffff;
    background-color: #e84c3d;
    font-size: 12px;
    padding: 0 6px;
  }

  .green {
    color: #00933e;
  }

  .red {
    color: #e84c3d;
  }
}

.body_foot_box {
  padding: 0 10px;
  height: 50px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #eee;
}

.setting_box {
  .setting_general {
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    .setting_table_size {
      margin-left: 30px;
    }
  }

  .setting_table_column_box {
    height: 200px;
    overflow-y: auto;

    .setting_table_column_item {
      padding: 5px;
    }
  }
}

::v-deep .confirm {
  td {
    .cell {
      color: #E84C3D;
    }
  }
}
</style>
<template>
  <div class="body_table_content_box">
    <div v-if="$slots.tableHeader" class="body_table_header_box">
      <slot name="tableHeader" />
    </div>
    <div class="body_table_box">
      <div class="body_table_title_box">
        <div class="body_table_title_left">
          <slot name="button" />
        </div>
        <div v-if="tableData.length" class="body_table_title_right">
          <el-link
            v-if="jurisdiction.indexOf(exportJurisdiction) != -1"
            :underline="false"
            style="margin-right:10px;"
            icon="el-icon-download"
            @click="exportDialog()"
          >导出</el-link>
          <el-link
            :underline="false"
            style="margin-right:10px;"
            icon="el-icon-refresh"
            @click="handleRefresh"
          >刷新</el-link>
          <el-popover placement="bottom" width="300" trigger="click">
            <div class="setting_box">
              <div class="setting_general">
                <el-tooltip class="item" effect="dark" content="可控制显示的表格字段，刷新后保持选择项。" placement="top-start">
                  <div slot="content">可控制显示的表格字段，刷新后保持选择项。<br>如果希望还原配置信息请清空浏览器缓存</div>
                  <help theme="filled" size="16" fill="#9b9b9b" style="margin-right: 10px" />
                </el-tooltip>
                <el-checkbox
                  v-model="selectAll"
                  :indeterminate="isIndeterminate"
                  @change="handleCheckAllChange"
                >全选</el-checkbox>
                <div class="setting_table_size">
                  <el-radio-group v-model="customParams.tableSize" @input="handleCheckTableSize">
                    <el-radio label="medium">表格大</el-radio>
                    <el-radio label="small">表格小</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="setting_table_column_box">
                <el-checkbox-group v-model="checkedColumn" @change="handleCheckedColumnGroupChange">
                  <template v-for="(item, index) in tableColumn">
                    <div v-if="!item.required" :key="index" class="setting_table_column_item">
                      <el-checkbox :label="item.prop" @change="handleCheckedColumnChange(index)">{{ item.label
                      }}</el-checkbox>
                    </div>
                  </template>
                </el-checkbox-group>
              </div>
            </div>
            <el-link slot="reference" :underline="false" icon="el-icon-setting">设置</el-link>
          </el-popover>
        </div>
      </div>
      <el-table
        v-if="tableData"
        ref="table"
        v-loading="loading"
        :row-class-name="setRowClass"
        :data="tableData"
        stripe
        height="100%"
        :size="customParams.tableSize"
        @selection-change="handleSelectionChange"
        @sort-change="sortableChange"
      >
        <el-table-column v-if="isCheck" type="selection" width="55" />
        <template v-for="item in customParams.tableColumn"> <!-- 需要单独处理的字段 -->
          <el-table-column
            v-if="item.columnType && item.display"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :width="item.width"
            :show-overflow-tooltip="!!item.showOverflowTooltip"
            :fixed="item.prop === 'option' ? 'right' : false"
            :class-name="item.prop === 'option' ? 'operation' : ''"
            :sortable="item.sortable || false"
          >
            <template slot="header">
              <slot :name="`${item.columnSlot}Header`" :data="item" />
            </template>
            <template slot-scope="{ row }">
              <slot :name="item.columnSlot" :data="row" />
            </template>
          </el-table-column>
          <!-- 不需要单独处理 -->
          <el-table-column
            v-if="!item.columnType && item.display"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :width="item.width"
            :sortable="item.sortable || false"
          >
            <template slot-scope="scope">
              <span v-if="item.date && getPropLevel(scope.row, item.prop)">
                {{ getPropLevel(scope.row, item.prop) | date(item.date) }}
              </span>
              <span v-else>{{ getPropLevel(scope.row, item.prop) || '-' }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-empty v-else description="暂无表格数据" />
    </div>
    <div class="body_foot_box">
      <el-pagination
        v-if="tableData && tableData.length > 0"
        background
        :page-size="page.pageSize"
        :page-sizes="$pageSizeOptions"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        :current-page="page.pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 导出功能 -->
    <ExportDialog
      v-if="exportDialogSwitch"
      :visible.sync="exportDialogSwitch"
      :select-data="selectData"
      :page-data="tableData"
      :all-data="page.total"
      @res-ids="retuenIds"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Help } from '@icon-park/vue'
import ExportDialog from './export-dialog.vue'
import _get from 'lodash/get'
export default {
  name: 'BaseTable',
  components: {
    Help,
    ExportDialog
  },
  props: {
    // 存入表格名称
    tableName: {
      type: String,
      default: ''
    },
    // loading加载
    loading: {
      type: Boolean,
      default: false
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    setRowClass: {
      type: Function,
      default: () => { }
    },

    /**
     * 表格列数据
     * prop       标识
     * label      名称
     * display    显示
     * minWidth   最小长度
     * columnType 需要处理的字段
     * columnSlot 插槽的名称
     * showOverflowTooltip  是否超长隐藏
     * required   是否取消自定义控制(如果display是权限控制的，那就加上required)
     */
    tableColumn: {
      type: Array,
      default: () => []
    },

    /**
     * 分页参数
     */
    page: {
      type: Object,
      default: () => { }
    },
    // 是否显示多选框
    isCheck: {
      type: Boolean,
      default: true
    },
    // 导出权限
    exportJurisdiction: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 0
    },
    debug: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectAll: true,
      checkedColumn: [],
      allColumn: [],
      isIndeterminate: true,
      selectData: [],
      exportDialogSwitch: false,
      // 通过localStorage拿最新的表格列数据
      customParams: {
        tableColumn: this.tableColumn,
        tableSize: 'medium'
      }
    }
  },
  computed: {
    ...mapGetters([
      'jurisdiction'
    ])
  },
  watch: {
    // 监听表格数据，修复fixed塌陷问题
    tableData(v) {
      this.$refs.table.doLayout()
    }
  },
  created() {
    // 获取存入的数值
    if (!this.tableName) {
      throw Error('调用子组件请填写表格名称')
    }
    if (this.debug) {
      this.customParams = {
        tableColumn: this.tableColumn,
        tableSize: 'medium'
      }
    } else {
      const sessionStorageCustomTable = sessionStorage.getItem(this.tableName)
      if (sessionStorageCustomTable) {
        this.customParams = JSON.parse(sessionStorageCustomTable)
      } else {
        sessionStorage.setItem(this.tableName, JSON.stringify(this.customParams))
      }
    }
  },
  mounted() {
    // 获取外层的高度并且带上传递过来的参数处理高度
    this.$nextTick(() => {
      if (!document.getElementById('body_main')) {
        throw new Error('当前组件没有获取到容器高度，请确认是否div加上id=body_main的属性')
      }
      document.getElementById('body_main').style.height = `calc(100vh - ${136 + this.height}px)`
    })

    for (const item of this.customParams.tableColumn) {
      if (!item.required) {
        this.allColumn.push(item.prop)
        if (item.display !== false) {
          this.checkedColumn.push(item.prop)
        }
      }
    }
    // 判断初始化全选多选框的状态
    this.isIndeterminate = this.checkedColumn.length > 0 && this.checkedColumn.length < this.allColumn.length
  },
  methods: {
    getPropLevel(row, prop) {
      if (prop.indexOf('.') > -1) {
        return _get(row, prop)
      } else {
        return row[prop] ? row[prop] : '-'
      }
    },
    handleCheckAllChange(val) {
      this.checkedColumn = val ? this.allColumn : []
      this.isIndeterminate = false
      // eslint-disable-next-line no-return-assign
      this.customParams.tableColumn.forEach((i) =>
        i.required !== true ? (i.display = val) : true
      )
      sessionStorage.setItem(this.tableName, JSON.stringify(this.customParams))
    },
    handleCheckedColumnGroupChange(value) {
      const checkedCount = value.length
      this.selectAll = checkedCount === this.allColumn.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.allColumn.length
      sessionStorage.setItem(this.tableName, JSON.stringify(this.customParams))
    },
    handleCheckedColumnChange(index) {
      this.customParams.tableColumn[index].display = !this.customParams.tableColumn[index].display
      sessionStorage.setItem(this.tableName, JSON.stringify(this.customParams))
    },
    handleCheckTableSize() {
      sessionStorage.setItem(this.tableName, JSON.stringify(this.customParams))
    },
    handleRefresh() {
      this.$message.success('刷新表格')
      this.$emit('handle-refresh')
    },
    handleSizeChange(v) {
      console.log(`每页 ${v} 条`)
      this.$parent.handleSizeChange(v)
    },
    handleCurrentChange(v) {
      console.log(`当前页: ${v}`)
      this.$parent.handleCurrentChange(v)
    },
    handleSelectionChange(val) {
      this.selectData = val
      const ids = Array.from(val, item => item.id)
      this.$emit('handle-select-ids', ids)
    },
    exportDialog() {
      if (!this.selectData.length) {
        this.$message.warning('请选择需要导出的数据')
        return
      }
      this.exportDialogSwitch = true
    },
    retuenIds(v) {
      this.exportDialogSwitch = false
      this.$emit('export-ids', v)
    },
    sortableChange(v) {
      const orderMapping = {
        'descending': 'desc',
        'ascending': 'aes'
      }
      const props = {
        order: orderMapping[v.order] || v.order,
        prop: v.prop
      }
      this.$parent.handleSortableChange(props)
    }
  }
}
</script>
